import { useEffect, useState } from 'react';
import { type ConfluenceTemplate, TemplateType } from '../../../../containers/template/types';
import { useTemplate } from '../../../../containers/template';

type UseSelectedTemplatePreviewProps = {
	isConfluenceActivationCompleteForPreselectedTemplate: boolean;
	onShouldShowEmbeddedConfluence: (template: ConfluenceTemplate) => boolean;
};

export function useShouldShowEmbeddedConfluence({
	isConfluenceActivationCompleteForPreselectedTemplate,
	onShouldShowEmbeddedConfluence,
}: UseSelectedTemplatePreviewProps) {
	const [hasShownEmbeddedConfluence, setHasShown] = useState(false);
	const { template } = useTemplate();

	useEffect(() => {
		if (
			!hasShownEmbeddedConfluence &&
			isConfluenceActivationCompleteForPreselectedTemplate &&
			template?.type === TemplateType.Confluence
		) {
			const didShow = onShouldShowEmbeddedConfluence(template);
			setHasShown(didShow);
		}
	}, [
		hasShownEmbeddedConfluence,
		isConfluenceActivationCompleteForPreselectedTemplate,
		template,
		onShouldShowEmbeddedConfluence,
	]);

	return hasShownEmbeddedConfluence;
}
